import script from "./eReader.vue?vue&type=script&setup=true&lang=js"
export * from "./eReader.vue?vue&type=script&setup=true&lang=js"

import "./eReader.vue?vue&type=style&index=0&id=6756805f&scoped=true&lang=scss"

import exportComponent from "/home/runner/work/shamudeen/shamudeen/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6756805f"]])

export default __exports__